// Is this address Intuit's own sign-in page, over https? App.js only leaves the app for such an address.
// Pure: parses with URL and checks the real host name, so look-alikes (intuit.com.evil.com, evilintuit.com,
// https://intuit.com@evil.com) are refused.
export function isIntuitSignInUrl(value) {
  if (typeof value !== 'string') return false;
  let u;
  try { u = new URL(value); } catch { return false; }
  if (u.protocol !== 'https:' || u.username || u.password) return false;
  return u.hostname === 'intuit.com' || u.hostname.endsWith('.intuit.com');
}
